import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Loading from "./Loading";
import BrowseFilters from "./BrowseFilters";
import theme from "../styles/theme";
import SimplePdfViewerModal from "./SimplePdfViewerModal";
import calendar from "../assets/icons/calendar.svg";
import compass from "../assets/icons/compass.svg";
import multiple from "../assets/icons/multiple-documents.svg";
import search from "../assets/icons/search.svg";
import "../styles/search-results.css";
import PageNumbers from "./PageNumbers";
import useBrowseResults from "../custom-hooks/useBrowseResults";

const PAGINATION_RANGE = 2;

const BrowseResults = () => {
  const {
    browseResults,
    setBrowseResults,
    loading,
    setLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    displayedRows,
    handlePageChange,
    modalOpen,
    selectedRow,
    handleRowClick,
    handleCloseModal,
    emptyRowsCount,
  } = useBrowseResults();

  return (
    <>
      <Loading isLoading={loading}>
        <div
          style={{ background: theme.colors.mainGrayBackground, width: "100%" }}
        >
          <Header />
          <div>
            <BrowseFilters
              setBrowseResults={setBrowseResults}
              setCurrentPage={setCurrentPage}
              setLoading={setLoading}
            />
          </div>
          {browseResults && browseResults.length > 0 && (
            <div className="row g-0 mt-4 ml-2 mr-2 browse-results-layout">
              <div className="col g-0 browse-results-col">
                <div className="row g-0 browse-results-table-container">
                  <table className="table">
                    <colgroup>
                      <col style={{ width: "16%" }} />
                      <col style={{ width: "22%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "16%" }} />
                      <col style={{ width: "20%" }} />
                      <col style={{ width: "12%" }} />
                    </colgroup>
                    <thead className="table-head">
                      <tr>
                        <th className="table-th browse-results-collection-col">
                          Collection
                        </th>
                        <th className="table-th">Title</th>
                        <th className="table-th">Date</th>
                        <th className="table-th">Location</th>
                        <th className="table-th">Source</th>
                        <th className="table-th browse-results-pages-col">
                          Pages
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayedRows.map((row, index) => (
                        <React.Fragment key={index}>
                          <tr
                            onClick={() => handleRowClick(row)}
                            style={{
                              borderBottom: "1px solid #E5E5E5",
                              cursor: "pointer",
                            }}
                          >
                            <td
                              className="ellipsis browse-results-collection-col"
                              data-label="Collection"
                            >
                              {row.coll_name}
                            </td>
                            <td className="ellipsis2" data-label="Title">
                              <div className="col g-0">
                                <div className="row g-0 title-text">
                                  {row.title}
                                </div>
                              </div>
                            </td>
                            <td data-label="Date">
                              <img
                                src={calendar}
                                className="table-icon"
                                alt="Calendar Icon"
                              />
                              {row.coll_type === "manuscript"
                                ? row.date_of_manuscript
                                : row.date_of_journal}
                            </td>
                            <td className="ellipsis" data-label="Location">
                              <img
                                src={compass}
                                className="table-icon"
                                alt="Compass Icon"
                              />
                              {row.coll_location}
                            </td>
                            <td className="ellipsis" data-label="Source">
                              <img
                                src={search}
                                className="table-icon"
                                alt="Search Icon"
                              />
                              {row.coll_source}
                            </td>
                            <td
                              className="ellipsis browse-results-pages-col"
                              data-label="Pages"
                            >
                              <img
                                src={multiple}
                                className="table-icon"
                                alt="Multiple Icon"
                              />
                              {row.number_of_pages}
                            </td>
                          </tr>
                          {emptyRowsCount > 0 &&
                            index === displayedRows.length - 1 && (
                              <tr style={{ height: 65 * emptyRowsCount }}>
                                <td colSpan={6} />
                              </tr>
                            )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
                <SimplePdfViewerModal
                  className="simple-pdf-viewer-modal"
                  show={modalOpen}
                  handleClose={handleCloseModal}
                  selectedRow={selectedRow}
                  searchQuery={""}
                />
                <div className="row mt-5 mb-5 g-0">
                  <div className="d-flex justify-content-center">
                    <PageNumbers
                      currentPage={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                      PAGINATION_RANGE={PAGINATION_RANGE}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* {isNewUser !== null && isNewUser && (
          <FeedbackPopup
            show={showFeedbackPopup}
            handleClose={handleCloseFeedbackPopup}
            fingerprint={fingerprint}
          />
        )} */}
        <Footer bgcolor="#FFFFFF" />
      </Loading>
    </>
  );
};

export default BrowseResults;
